import React from "react";

import styles from "./card.module.scss";

interface IProps {
  className?: string;
  expandToHeight?: boolean;
  includeBody?: boolean;
  bodyClassName?: string;
}

const Card: React.FC<IProps> = (props) => {

  const getClasses = (className?: string, expandToHeight?: boolean) => {
    let passedClass = className !== undefined ? ` ${className}` : "";
    let expandClass = expandToHeight ? ` ${styles.cardExpanded}` : "";
    return `card ${styles.card}${passedClass}${expandClass}`;
  }

  const getBodyClass = (bodyClass?: string) => {
    return bodyClass !== undefined ? ` ${bodyClass}` : "";
  };
  

  const renderBody = (children?: React.ReactNode, includeBody?: boolean): JSX.Element => {
    if (includeBody) {
      return (
        <div className={`card-body${getBodyClass(props.bodyClassName)}`}>
          {children}
        </div>
      );
    } else {
      return (
        <>{children}</>
      );
    }
  }

  return (
    <div className={getClasses(props.className, props.expandToHeight)}>
      {renderBody(props.children, props.includeBody)}
    </div>
  );
};

export default Card;
